import { api } from "../api/client";

// Envoi « best-effort » d'un événement analytique : on n'attend pas la réponse
// et on ignore les erreurs pour ne jamais gêner l'action de l'utilisateur.
export type TrackEvent = {
  type:
    | "reservation_click"
    | "reservation_open"
    | "phone_click"
    | "email_click"
    | "directions_click"
    | "pricing_interest";
  gym?: string;
  path?: string;
  meta?: Record<string, unknown>;
};

export function track(event: TrackEvent) {
  api("/analytics/event", { method: "POST", json: event }).catch(() => {});
}
